module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_credit_card_m.d96099002cd847294385a87b565dff94.png";